"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _components = require("@quarkly/components");

var _widgets = require("@quarkly/widgets");

var _components2 = require("./components");

var _hooks = require("./hooks");

var _props = require("./props");

var _store = require("./store");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Component = function Component(_ref) {
  var aspectRatio = _ref.aspectRatio,
      slidesWrapper = _ref.slidesWrapper,
      showArrows = _ref.showArrows,
      showDots = _ref.showDots,
      showHead = _ref.showHead,
      showText = _ref.showText,
      showLink = _ref.showLink,
      props = _objectWithoutProperties(_ref, ["aspectRatio", "slidesWrapper", "showArrows", "showDots", "showHead", "showText", "showLink"]);

  var _useOverrides = (0, _components.useOverrides)(props, _props.overrides),
      override = _useOverrides.override,
      rest = _useOverrides.rest;

  var _useResize = (0, _hooks.useResize)(aspectRatio),
      _useResize2 = _slicedToArray(_useResize, 3),
      sliderRef = _useResize2[0],
      width = _useResize2[1],
      height = _useResize2[2];

  var slidesRef = (0, _react.useRef)(null);

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state;
  }),
      slidesNumb = _useSelector.slidesNumb,
      slidesList = _useSelector.slidesList,
      animDuration = _useSelector.animDuration,
      animFunction = _useSelector.animFunction,
      active = _useSelector.active,
      position = _useSelector.position,
      animate = _useSelector.animate;

  var dispatch = (0, _reactRedux.useDispatch)();
  var clickNumb = (0, _react.useCallback)(function (newActive) {
    return dispatch({
      type: 'CLICK_NUMB',
      active: newActive
    });
  }, [dispatch]);
  var onClickPrev = (0, _react.useCallback)(function () {
    dispatch((0, _store.clickPrev)());
  }, [dispatch]);
  var onClickNext = (0, _react.useCallback)(function () {
    dispatch((0, _store.clickNext)());
  }, [dispatch]);
  (0, _hooks.useKeyboard)(sliderRef, onClickNext, onClickPrev);
  return /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    ref: sliderRef,
    position: "relative",
    "align-self": "normal",
    overflow: "hidden"
  }, rest), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    ref: slidesRef
  }, override('Slides'), {
    transform: "translateX(-".concat(position, "%)"),
    transition: animate ? "transform ".concat(animDuration, "ms ").concat(animFunction) : 'none'
  }), slidesList.map(function (numb, index) {
    return /*#__PURE__*/_react["default"].createElement(_components2.Slide, {
      key: "".concat(rest['data-qid'], "-slide-").concat(numb, "-").concat(index) // eslint-disable-line
      ,
      index: index,
      slides: slidesNumb,
      slidesWrapper: slidesWrapper,
      numb: numb,
      width: width,
      height: height,
      showHead: showHead,
      showText: showText,
      showLink: showLink,
      override: override
    });
  })), showArrows && /*#__PURE__*/_react["default"].createElement(_widgets.Box, override('Arrows'), /*#__PURE__*/_react["default"].createElement(_components2.Arrow, {
    type: "Prev",
    clickFunc: onClickPrev,
    override: override
  }), /*#__PURE__*/_react["default"].createElement(_components2.Arrow, {
    type: "Next",
    clickFunc: onClickNext,
    override: override
  })), showDots && /*#__PURE__*/_react["default"].createElement(_widgets.Box, override('Points'), slidesList.slice(1, -1).map(function (numb, index) {
    return /*#__PURE__*/_react["default"].createElement(_components2.Point, {
      key: "point-".concat(numb, "-").concat(index) // eslint-disable-line
      ,
      numb: numb,
      active: active,
      clickFunc: clickNumb,
      override: override
    });
  })));
};

var _default = Component;
exports["default"] = _default;